import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot re-loadable.
 */

import { ReduxUtils } from '@spm/core';
import ApplicationReducers from '../Application/reducers';
import ApplicationFormReducers from '../ApplicationForm/reducers';
import ApplicationFormOwnershipReducers from '../ApplicationFormOwnership/reducers';
import ApplicationOverviewReducers from '../ApplicationOverview/reducers';
import ApplyForBenefitsReducers from '../ApplyForBenefits/reducers';
import BenefitSelectionReducers from '../BenefitSelection/reducers';
import CaseworkersReducers from '../Caseworkers/reducers';
import DraftApplicationsReducers from '../DraftApplications/reducers';
import LoginReducers from '../Login/reducers';
import LifeEventCategoriesReducers from '../LifeEventCategories/reducers';
import * as MessagesReducers from '../Messages/reducers';
import OrganisationReducers from '../Organisation/reducers';
import * as PaymentsReducers from '../Payments/reducers';
import ScreeningReducers from '../Screening/reducers';
import LifeEventsReducers from '../LifeEvents/reducers';
import SubmissionFormReducers from '../SubmissionForm/reducers';
import SubmittedApplicationsReducers from '../SubmittedApplications/reducers';
import * as WithdrawRequestReasonsReducers from '../WithdrawRequestReasons/reducers';
import * as WithdrawReducers from '../Withdraw/reducers'; // generated

import UAGeneratedReducers from '../../generated/combinedReducers';
/**
 * Creates the main reducer which combines all the reducers from the modules
 * and any provided reducers supplied from the wrapping application.
 *
 * Provided reducers are ignored where there is a clash in naming.
 *
 * @namespace UAReduxReducers
 */

export default _Object$assign({}, UAGeneratedReducers, {
  /**
   * Holds the application state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAApplication: ApplicationReducers.reducers,

  /**
   * Holds the application form state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAApplicationForm: ApplicationFormReducers.reducers,

  /**
   * Holds the application form ownership state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAApplicationFormOwnership: ApplicationFormOwnershipReducers.reducers,

  /**
   * Holds the apply for benefits state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAApplyForBenefits: ApplyForBenefitsReducers.reducers,

  /**
   * Holds the application overview state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAApplicationOverview: ApplicationOverviewReducers.reducers,

  /**
   * Holds the organisation state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAOrganisation: OrganisationReducers.rootReducer,

  /**
   * Holds the caseworkers state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UACaseworkers: CaseworkersReducers.rootReducer,

  /**
   * Holds the benefit selection state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UABenefitSelection: BenefitSelectionReducers.reducers,

  /**
   * Holds the draft applications state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UADraftApplications: DraftApplicationsReducers.rootReducer,

  /**
   * Holds the Login state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UALogin: LoginReducers.reducers,

  /**
   * Holds the LifeEventCategories state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UALifeEventCategories: LifeEventCategoriesReducers.reducers,

  /**
   * Holds the messages state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAMessages: MessagesReducers.reducers,

  /**
   * Holds the payments state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAPayments: PaymentsReducers.reducers,

  /**
   * Holds the screening state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAScreening: ScreeningReducers.reducers,

  /**
   * Holds the user signup state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UALifeEvents: LifeEventsReducers.reducers,

  /**
   * Holds the application submission form state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASubmissionForm: SubmissionFormReducers.reducers,

  /**
   * Holds the submitted application state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASubmittedApplications: SubmittedApplicationsReducers.rootReducer,

  /**
   * Holds the withdraw application reasons state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAWithdrawRequestReasons: WithdrawRequestReasonsReducers.reducers,

  /**
   * Holds the withdraw application state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAWithdraw: WithdrawReducers.reducers,

  /**
   * Holds the app spinner state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAAppSpinner: ReduxUtils.generateGlobalFetchingReducer,

  /**
   * Holds the global error state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAErrors: ReduxUtils.generateGlobalErrorReducer
});